import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Class } from '../models/class.model';
import { environment } from 'src/environments/environment';
import * as globals from '../training/globals';

const baseUrl = `${environment.apis.connect}/${globals.CLASSES}`;

@Injectable({
  providedIn: 'root',
})

export class ClassesService {
  constructor(
    private http: HttpClient) { }

  getClasses(): Observable<Class[]> {
    return this.http.get<Class[]>(`${baseUrl}/${globals.GET_CLASSES}`);
  }

  getClassById(id: number): Observable<Class> {
    return this.http.get<Class>(`${baseUrl}/${globals.GET_CLASS}/${id}`);
  }

  create_class(data: any): Observable<any> {
    return this.http.post(`${baseUrl}/${globals.CREATE_CLASS}`, data);
  }

  isCLass_exists(id: number, class_name: string): Observable<boolean> {
    return this.http.get<boolean>(`${baseUrl}/${globals.IS_CLASS_EXISTS}/${id}?${globals.CLASS_NAME}=${class_name}`);
  }

  isClassExists_Dataset(id: number): Observable<boolean> {
    return this.http.get<boolean>(`${baseUrl}/${globals.IS_CLASS_EXISTS_DATASET}/${id}`);
  }

  update_class(data: any): Observable<any> {
    return this.http.post(`${baseUrl}/${globals.UPDATE_CLASS}`, data);
  }

  deleteClass(id: any): Observable<any> {
    return this.http.delete(`${baseUrl}/${globals.DELETE_CLASS}/${id}`);
  }

}
